import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'modalWrapper', 'modal')`
    ${propStyles};
    @media (min-width: ${props => props.theme?.breakpoints?.md}) {
        top: 5%;
        right: 15%;
        left: 15%;
    }
    @media (max-width: ${props => props.theme?.breakpoints?.md}) {
        top: 10px;
        right: 10px;
        bottom: 10px;
        left: 10px;
        justify-content: flex-start;
    }
`;

StyledComponent.defaultProps = {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    background: 'white',
    boxShadow: '0 5px 15px -5px',
    borderRadius: '0.25em',
    padding: '1em',
    zIndex: '1001',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalWrapper.tsx